module.exports = {
	"name": "Allen Rumsey Supper Club",
	"foodRecommendations": [],
	"address": "615 E Huron St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.281508,
		"lng": -83.741496
	},
	"catImage": "greenstar.png",
	"totalCats": 1,
	"totalMisc": 0,
	"categories": {
		"location": 1,
		"fooddrink": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/allenrumseysupperclub.json
// module id = 805
// module chunks = 0